import { Navigate, Outlet, useLocation } from 'react-router';
import { getAdminToken } from '../../services/adminAuthService';

export default function ProtectedAdminRoute() {
  const location = useLocation();
  const adminToken = getAdminToken();

  if (!adminToken) {
    return <Navigate to='/myadmin' replace state={{ from: location }} />;
  }

  return <Outlet />;
}
